import 'moment/locale/fr';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MomentModule } from 'ngx-moment';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { ResponseInterceptor } from './interceptors/response';
import { AuthService } from './services/auth.service';
import { environment } from '@environments/environment';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [NotFoundComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN-DOCOPRL',
      headerName: 'X-XSRF-TOKEN-DOCOPRL',
    }),
    SharedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: preloadUserDataFactory,
      deps: [AuthService],
      multi: true,
    },
  ],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, MomentModule, SharedModule, RouterModule],
})
export class PrlCoreModule {}

///////////////////

export function preloadUserDataFactory(AuthService: AuthService) {
  return () => {
    AuthService.listenToLogoutFromOtherTabs();
    return AuthService.populate();
  };
}
